import { LocationResponse } from 'containers/ServicesPage/types';
import {
  GET_LAST_NOTIFICATION,
  SET_LAST_NOTIFICATION,
  GET_LAST_NOTIFICATION_FAILED,
  SET_NOTIFICATION_READ,
  SET_NOTIFICATION_READ_SUCCESS,
  SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH,
  GET_VIMEO_THUMBNAIL_SRC,
  GET_VIMEO_THUMBNAIL_SRC_SUCCESS,
  GET_VIMEO_THUMBNAIL_SRC_FAILED,
  SET_TABS,
  SET_TOASTER_OPEN,
  SET_TOASTER_CLOSE,
  OPEN_MODAL_SERVICES_AUTO,
  CLOSE_MODAL_SERVICES_AUTO,
  OPEN_MODAL_SERVICES_MRH,
  CLOSE_MODAL_SERVICES_MRH,
  SET_SELECTED_TAB,
  GET_FAQ,
  SET_FAQ,
  GET_FAQ_FAILED,
  REPORT_BUG,
  REPORT_BUG_SUCCESS,
  REPORT_BUG_FAIL,
  GET_LOCATIONS,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  SET_FAQ_SEARCHED,
  GET_CONTACTS,
  GET_CONTACTS_FAILURE,
  GET_CONTACTS_SUCCESS,
  SET_SELECTED_FAQ,
  SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH,
  SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH,
  OPEN_MODAL_CREATE_FOLDER,
  CLOSE_MODAL_CREATE_FOLDER,
  OPEN_MODAL_PAC,
  CLOSE_MODAL_PAC,
  OPEN_MODAL_CHOICE_ORGANISME,
  CLOSE_MODAL_CHOICE_ORGANISME,
} from 'store/global/constants';
import {
  getLastNotificationType,
  setLastNotificationType,
  getLastNotificationFailedType,
  setNotificationReadSuccessType,
  setNotificationReadType,
  setNotificationReadSuccessPayloadType,
  setLastNotificationPayloadType,
  setNotificationReadPayloadType,
  setDetailsPageBreadCrumbsPathPayloadType,
  setAutoDetailsPageBreadCrumbsPathType,
  setEpargnDetailsPageBreadCrumbsPathType,
  setMrhDetailsPageBreadCrumbsPathType,
  getVimeoThumbnailSrcType,
  getVimeoThumbnailSrcSuccessType,
  getVimeoThumbnailSrcFailedType,
  setTabsType,
  setToasterOpenType,
  setToasterCloseType,
  openModalServicesAutoType,
  closeModalServicesAutoType,
  openModalServicesMrhType,
  closeModalServicesMrhType,
  setSelectedTabType,
  getFaqType,
  setFaqType,
  getFaqFailedType,
  ReportBugType,
  ReportBugSuccessType,
  ReportBugFailType,
  GetLocationsSuccessType,
  GetLocationsFailureType,
  GetLocationsType,
  GetContactsSuccessType,
  GetContactsFailureType,
  GetContactsType,
  setSelectedFaqType,
  setAMCDetailsPageBreadcrumbsPathType,
  setASIDetailsPageBreadcrumbsPathType,
  openModalCreateFolderType,
  closeModalCreateFolderType,
  openModalPACType,
  closeModalPACType,
  openModalOrganismeType,
  closeModalOrganismeType,
} from 'store/global/types';
import { Tab } from 'store/user/types';

export const getLastNotification = (
  payload: string,
): getLastNotificationType => ({
  type: GET_LAST_NOTIFICATION,
  payload,
});

export const setLastNotification = (
  payload: setLastNotificationPayloadType,
): setLastNotificationType => ({
  type: SET_LAST_NOTIFICATION,
  payload,
});

export const getLastNotificationFailed = (): getLastNotificationFailedType => ({
  type: GET_LAST_NOTIFICATION_FAILED,
});
export const setNotificationRead = (
  payload: setNotificationReadPayloadType,
): setNotificationReadType => ({
  type: SET_NOTIFICATION_READ,
  payload,
});
export const setNotificationReadSuccess = (
  payload: setNotificationReadSuccessPayloadType,
): setNotificationReadSuccessType => ({
  type: SET_NOTIFICATION_READ_SUCCESS,
  payload,
});
export const setNotificationReadFailed = (): getLastNotificationFailedType => ({
  type: GET_LAST_NOTIFICATION_FAILED,
});

export const setAutoDetailsPageBreadcrumbsPath = (
  payload: setDetailsPageBreadCrumbsPathPayloadType,
): setAutoDetailsPageBreadCrumbsPathType => ({
  type: SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH,
  payload,
});

export const setMrhDetailsPageBreadcrumbsPath = (
  payload: setDetailsPageBreadCrumbsPathPayloadType,
): setMrhDetailsPageBreadCrumbsPathType => ({
  type: SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH,
  payload,
});

export const setEpargnDetailsPageBreadcrumbsPath = (
  payload: setDetailsPageBreadCrumbsPathPayloadType,
): setEpargnDetailsPageBreadCrumbsPathType => ({
  type: SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH,
  payload,
});

export const setAMCDetailsPageBreadcrumbsPath = (
  payload: setDetailsPageBreadCrumbsPathPayloadType,
): setAMCDetailsPageBreadcrumbsPathType => ({
  type: SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH,
  payload,
});

export const setASIDetailsPageBreadcrumbsPath = (
  payload: setDetailsPageBreadCrumbsPathPayloadType,
): setASIDetailsPageBreadcrumbsPathType => ({
  type: SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH,
  payload,
});

export const getVimeoThumbnailSrc = (
  payload: string,
): getVimeoThumbnailSrcType => ({
  type: GET_VIMEO_THUMBNAIL_SRC,
  payload,
});

export const getVimeoThumbnailSrcSuccess = (
  payload: string,
): getVimeoThumbnailSrcSuccessType => ({
  type: GET_VIMEO_THUMBNAIL_SRC_SUCCESS,
  payload,
});

export const getVimeoThumbnailSrcFailed = (
  payload: string,
): getVimeoThumbnailSrcFailedType => ({
  type: GET_VIMEO_THUMBNAIL_SRC_FAILED,
  payload,
});
export const SetTabs = (payload: Tab[] | []): setTabsType => ({
  type: SET_TABS,
  payload,
});

export const setToasterOpen = (payload: {
  title?: string;
  message?: string;
  subTitle?: string;
  severity: string;
}): setToasterOpenType => ({
  type: SET_TOASTER_OPEN,
  payload,
});

export const setToasterClose = (): setToasterCloseType => ({
  type: SET_TOASTER_CLOSE,
});
export const openModalServicesAuto = (): openModalServicesAutoType => ({
  type: OPEN_MODAL_SERVICES_AUTO,
});
export const closeModalServicesAuto = (): closeModalServicesAutoType => ({
  type: CLOSE_MODAL_SERVICES_AUTO,
});
export const openModalServicesMrh = (): openModalServicesMrhType => ({
  type: OPEN_MODAL_SERVICES_MRH,
});
export const closeModalServicesMrh = (): closeModalServicesMrhType => ({
  type: CLOSE_MODAL_SERVICES_MRH,
});
export const setSelectedTab = (payload: string): setSelectedTabType => ({
  type: SET_SELECTED_TAB,
  payload,
});
export const getFaq = (payload: any): getFaqType => ({
  type: GET_FAQ,
  payload,
});
export const setFaq = (payload: any): setFaqType => ({
  type: SET_FAQ,
  payload,
});
export const getFaqFailed = (payload: string): getFaqFailedType => ({
  type: GET_FAQ_FAILED,
  payload,
});

export const reportBug = (payload: any): ReportBugType => ({
  type: REPORT_BUG,
  payload: payload,
});

export const reportBugSuccess = (): ReportBugSuccessType => ({
  type: REPORT_BUG_SUCCESS,
});

export const reportBugFailed = (): ReportBugFailType => ({
  type: REPORT_BUG_FAIL,
});

export const getLocations = (payload: {
  filterWith: string;
  latitude: number;
  longitude: number;
  research: string;
}): GetLocationsType => ({
  type: GET_LOCATIONS,
  payload,
});

export const getLocationsSuccess = (
  payload: LocationResponse[],
): GetLocationsSuccessType => ({
  type: GET_LOCATIONS_SUCCESS,
  payload,
});

export const getLocationsFailure = (
  payload: string,
): GetLocationsFailureType => ({
  type: GET_LOCATIONS_FAILURE,
  payload,
});

export const getContacts = (payload: string): GetContactsType => ({
  type: GET_CONTACTS,
  payload,
});

export const getContactsSuccess = (payload: any): GetContactsSuccessType => ({
  type: GET_CONTACTS_SUCCESS,
  payload,
});

export const getContactsFailure = (
  payload: string,
): GetContactsFailureType => ({
  type: GET_CONTACTS_FAILURE,
  payload,
});
export const setSearchFaq = (payload: any) => ({
  type: SET_FAQ_SEARCHED,
  payload,
});
export const setSelectedFaq = (payload: any): setSelectedFaqType => ({
  type: SET_SELECTED_FAQ,
  payload,
});
export const openModalCreateFolder = (): openModalCreateFolderType => ({
  type: OPEN_MODAL_CREATE_FOLDER,
});
export const closeModalCreateFolder = (): closeModalCreateFolderType => ({
  type: CLOSE_MODAL_CREATE_FOLDER,
});

export const openModalPAC = (): openModalPACType => ({
  type: OPEN_MODAL_PAC,
});
export const closeModalPAC = (): closeModalPACType => ({
  type: CLOSE_MODAL_PAC,
});

export const openModalOrganisme = (): openModalOrganismeType => ({
  type: OPEN_MODAL_CHOICE_ORGANISME,
});
export const closeModalOrganisme = (): closeModalOrganismeType => ({
  type: CLOSE_MODAL_CHOICE_ORGANISME,
});
